import { User } from '../models/user.model';
import { UsuarioAutorizacoes } from '../models/usuario.autorizacoes.model';
import { PodeAcessarViewModel } from '../pages/domain/viewmodels.models';

export class Security {
    public static set(user: User, token: string, autorizacoes: UsuarioAutorizacoes[], podeAcessar: PodeAcessarViewModel ) {
        const data = JSON.stringify(user);
        localStorage.setItem('sigemscampuser', btoa(data));
        localStorage.setItem('sigescamptoken', token);
        localStorage.setItem('sigescampaut', JSON.stringify(autorizacoes) )
        localStorage.setItem('sigescamppodeacessar', JSON.stringify(podeAcessar))
    }

    public static setUser(user: User) {
        const data = JSON.stringify(user);
        localStorage.setItem('sigemscampuser', btoa(data));
    }

    public static setToken(token: string) {
        localStorage.setItem('sigescamptoken', token);
    }

    public static getUser(): User {
        const data = localStorage.getItem('sigemscampuser');
        if (data) {
            return JSON.parse(atob(data));
        } else {
            return null;
        }
    }

    public static getPodeAcessar(): PodeAcessarViewModel {
        const data = localStorage.getItem('sigescamppodeacessar');
        if (data) {
            return JSON.parse(data);
        } else {
            return null;
        }
    }


    public static getAutorizacoes(): UsuarioAutorizacoes[] {
        const data = localStorage.getItem('sigescampaut');
        if (data) {
            return JSON.parse(data);
        } else {
            return null;
        }
    }


    public static getToken(): string {
        const data = localStorage.getItem('sigescamptoken');
        if (data) {
            return data;
        } else {
            return null;
        }
    }

    public static hasToken(): boolean {
        if (this.getToken()) {
            return true;
        } else {
            return false;
        }
    }

    public static clear() {
        localStorage.removeItem('sigemscampuser');
        localStorage.removeItem('sigescamptoken');
        localStorage.removeItem('sigescampaut');
        localStorage.removeItem('sigescamppodeacessar');
    }
   
}
